import { Wrapper, Container } from './style'
import Sidebar from '../../components/sidebar/Sidebar'

interface ILayout {
  children: React.ReactElement<any, string | React.JSXElementConstructor<any>>
}

function Layout(props: ILayout) {
  return (
    <Wrapper dir="rtl">
      <Sidebar />
      <Container>{props.children}</Container>
    </Wrapper>
  )
}

export default Layout
